var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsSortNone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 11,
    viewBox: "0 0 9 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.65625 4.75H7.84375C8.14062 4.73438 8.34375 4.60156 8.45312 4.35156C8.54688 4.10156 8.5 3.86719 8.3125 3.64844L5.21875 0.4375C5.07812 0.3125 4.92188 0.25 4.75 0.25C4.57812 0.25 4.42969 0.3125 4.30469 0.4375L1.1875 3.64844C1 3.86719 0.953125 4.10156 1.04688 4.35156C1.15625 4.60156 1.35938 4.73438 1.65625 4.75ZM7.84375 6.25H1.65625C1.35938 6.26562 1.15625 6.39844 1.04688 6.64844C0.953125 6.89844 1 7.13281 1.1875 7.35156L4.30469 10.5625C4.41406 10.6875 4.5625 10.75 4.75 10.75C4.92188 10.75 5.07812 10.6875 5.21875 10.5625L8.3125 7.35156C8.5 7.13281 8.54688 6.89844 8.45312 6.64844C8.34375 6.39844 8.14062 6.26562 7.84375 6.25Z",
    fill: "#CBD2D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsSortNone);
export default __webpack_public_path__ + "static/media/icons_sort_none.ed280049.svg";
export { ForwardRef as ReactComponent };